exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.notice{border-radius:10px;border:1px solid #969696;color:#212121;padding:24px;margin:16px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/notice.scss
// module id = 951
// module chunks = 0